// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { foodNutrientTypeId } from './FoodNutrientType';
import { attributeKindEnum } from './AttributeKindEnum';
import { invResourceId } from './InvResource';
import { invResourceCategoryId } from './InvResourceCategory';
import { mediaAttachmentTypeEnum } from './MediaAttachmentTypeEnum';
import { textInputModeEnum } from './TextInputModeEnum';
import { testAttributeCodeCode } from './TestAttributeCode';
import { testAttributePhaseEnum } from './TestAttributePhaseEnum';
import { testTemplateRevisionId } from './TestTemplateRevision';
import { testAttributeLineageId } from './TestAttributeLineage';
import { z } from 'zod';
export const testTemplateAttributeId = (z.number());
export const testTemplateAttribute = z.object({
    id: testTemplateAttributeId,
    default_value_number: z.string().nullable(),
    default_value_measurement_unit: z.string().nullable(),
    default_check_value: z.boolean().nullable(),
    display_order: z.number().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    is_specification: z.boolean(),
    spec_details: z.string().nullable(),
    spec_target_value_number: z.string().nullable(),
    spec_abs_tol_upper: z.string().nullable(),
    spec_abs_tol_lower: z.string().nullable(),
    spec_target_value_unit: z.string().nullable(),
    spec_target_check_value: z.boolean().nullable(),
    food_nutrient_type_id: foodNutrientTypeId.nullable(),
    name: z.string(),
    kind: attributeKindEnum,
    description: z.string().nullable(),
    measurement_default_unit: z.string().nullable(),
    measurement_instructions: z.string().nullable(),
    computed_number_formula: z.string().nullable(),
    computed_number_result_base_unit: z.string().nullable(),
    computed_number_result_display_unit: z.string().nullable(),
    check_instructions: z.string().nullable(),
    inv_item_resource_id: invResourceId.nullable(),
    inv_item_resource_category_id: invResourceCategoryId.nullable(),
    media_attachment_type: mediaAttachmentTypeEnum.nullable(),
    text_input_mode: textInputModeEnum.nullable(),
    text_instructions: z.string().nullable(),
    text_options: z.unknown().nullable(),
    content_html: z.string().nullable(),
    code: testAttributeCodeCode.nullable(),
    phase: testAttributePhaseEnum.nullable(),
    test_template_revision_id: testTemplateRevisionId,
    lineage_id: testAttributeLineageId,
    managed_key: z.string().nullable(),
});
export const testTemplateAttributeInitializer = z.object({
    id: testTemplateAttributeId.optional(),
    default_value_number: z.string().optional().nullable(),
    default_value_measurement_unit: z.string().optional().nullable(),
    default_check_value: z.boolean().optional().nullable(),
    display_order: z.number().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    is_specification: z.boolean().optional(),
    spec_details: z.string().optional().nullable(),
    spec_target_value_number: z.string().optional().nullable(),
    spec_abs_tol_upper: z.string().optional().nullable(),
    spec_abs_tol_lower: z.string().optional().nullable(),
    spec_target_value_unit: z.string().optional().nullable(),
    spec_target_check_value: z.boolean().optional().nullable(),
    food_nutrient_type_id: foodNutrientTypeId.optional().nullable(),
    name: z.string(),
    kind: attributeKindEnum,
    description: z.string().optional().nullable(),
    measurement_default_unit: z.string().optional().nullable(),
    measurement_instructions: z.string().optional().nullable(),
    computed_number_formula: z.string().optional().nullable(),
    computed_number_result_base_unit: z.string().optional().nullable(),
    computed_number_result_display_unit: z.string().optional().nullable(),
    check_instructions: z.string().optional().nullable(),
    inv_item_resource_id: invResourceId.optional().nullable(),
    inv_item_resource_category_id: invResourceCategoryId.optional().nullable(),
    media_attachment_type: mediaAttachmentTypeEnum.optional().nullable(),
    text_input_mode: textInputModeEnum.optional().nullable(),
    text_instructions: z.string().optional().nullable(),
    text_options: z.unknown().optional().nullable(),
    content_html: z.string().optional().nullable(),
    code: testAttributeCodeCode.optional().nullable(),
    phase: testAttributePhaseEnum.optional().nullable(),
    test_template_revision_id: testTemplateRevisionId,
    lineage_id: testAttributeLineageId,
    managed_key: z.string().optional().nullable(),
});
export const testTemplateAttributeMutator = z.object({
    id: testTemplateAttributeId.optional(),
    default_value_number: z.string().optional().nullable(),
    default_value_measurement_unit: z.string().optional().nullable(),
    default_check_value: z.boolean().optional().nullable(),
    display_order: z.number().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    is_specification: z.boolean().optional(),
    spec_details: z.string().optional().nullable(),
    spec_target_value_number: z.string().optional().nullable(),
    spec_abs_tol_upper: z.string().optional().nullable(),
    spec_abs_tol_lower: z.string().optional().nullable(),
    spec_target_value_unit: z.string().optional().nullable(),
    spec_target_check_value: z.boolean().optional().nullable(),
    food_nutrient_type_id: foodNutrientTypeId.optional().nullable(),
    name: z.string().optional(),
    kind: attributeKindEnum.optional(),
    description: z.string().optional().nullable(),
    measurement_default_unit: z.string().optional().nullable(),
    measurement_instructions: z.string().optional().nullable(),
    computed_number_formula: z.string().optional().nullable(),
    computed_number_result_base_unit: z.string().optional().nullable(),
    computed_number_result_display_unit: z.string().optional().nullable(),
    check_instructions: z.string().optional().nullable(),
    inv_item_resource_id: invResourceId.optional().nullable(),
    inv_item_resource_category_id: invResourceCategoryId.optional().nullable(),
    media_attachment_type: mediaAttachmentTypeEnum.optional().nullable(),
    text_input_mode: textInputModeEnum.optional().nullable(),
    text_instructions: z.string().optional().nullable(),
    text_options: z.unknown().optional().nullable(),
    content_html: z.string().optional().nullable(),
    code: testAttributeCodeCode.optional().nullable(),
    phase: testAttributePhaseEnum.optional().nullable(),
    test_template_revision_id: testTemplateRevisionId.optional(),
    lineage_id: testAttributeLineageId.optional(),
    managed_key: z.string().optional().nullable(),
});
//# sourceMappingURL=TestTemplateAttribute.js.map